export default __webpack_public_path__ + "static/media/forall~GQauqjYz.40e01f65.svg";